import React, { useCallback, useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import { getCleanUrl, toBool } from '../../../utils/Helper';
import moment from 'moment';
import CustomPressable from '../../../components/customPressable/customPressable';
import { CustomTextInput } from '../../../components/customTextInput';
import DatePickerModal from '../../../components/datePickerModal/datePickerModal';
import { formatDate } from '../../../js/formatDate';
import CustomDropDown from '../../../components/customDropdown/customDropdown';
import { setRenderFlashMessage } from '../../../Redux/Actions/appConfigAction';

const ReservationDetails = (props) => {
    const { selectedVenue, preferredVenueDetails, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice?.extraConfigParam) || false;
    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;

    const { myReservations } = useSelector(state => state.tableReservationSlice);

    const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);

    const [selectedDate, setSelectedDate] = useState();
    const [guestCount, setGuestCount] = useState(null);

    const [etaTimeList, setETATimeList] = React.useState([]);
    const [startTime, setStartTime] = React.useState("");
    const [endTime, setEndTime] = React.useState("");


    const handleDateChange = useCallback((selectedDate) => {
        setIsDatePickerVisible(false);
        setSelectedDate(moment(selectedDate).format('YYYY-MM-DD'));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const generateTimeOptions = () => {
        const options = [];
        for (let hours = 0; hours < 24; hours++) {
            for (let minutes = 0; minutes < 60; minutes += 30) {
                const hourString = String(hours).padStart(2, '0');
                const minuteString = String(minutes).padStart(2, '0');
                const timeValue = `${hourString}:${minuteString}`;
                const formatedTimeValue = timeValue;
                options.push(formatedTimeValue);
            }
        }
        setETATimeList(options);
    };

    const formatEstimateCheckInTime = (time, timeFormat12hrs) => {
        if (!time) {
            return "";
        }

        const [hours, minutes] = time.split(":");
        if (timeFormat12hrs) {
            let period = "AM";
            let hour = parseInt(hours, 10);
            if (hour >= 12) {
                period = "PM";
                if (hour > 12) {
                    hour -= 12;
                }
            }
            return `${hour}:${minutes} ${period}`;
        } else {
            return `${hours}:${minutes}`;
        }
    }


    const updateDataFromProps = () => {
        setStartTime(preferredVenueDetails.startTime);
        setEndTime(preferredVenueDetails.endTime);
        setGuestCount(preferredVenueDetails.guestCount || null);
        setSelectedDate(preferredVenueDetails.date || "");
    }

    const handleGoNext = () => {
        if(!selectedDate){
            dispatch(setRenderFlashMessage(true, { type: "danger", message: t('reservations.select_preferred_date') }))
            return;
        }

        if(!guestCount || guestCount == 0){
            dispatch(setRenderFlashMessage(true, { type: "danger", message: t('reservations.select_guest_count') }))
            return;
        }


        let preferredVenueDetailsPayload = {
            "date": selectedDate,
            "guestCount": guestCount,
            "startTime": startTime,
            "endTime": endTime,
        }
        handleNext(preferredVenueDetailsPayload)
    }



    useEffect(() => {
        generateTimeOptions();
        updateDataFromProps();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])




    const renderHeader = () => {
        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'sevenRoomsVenueListHeaderContainer'])} id='sevenRoomsVenueListHeaderContainer'>
                {
                    currentWidget?.widgetHeaderImageUrl && <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'sevenRoomsVenueListHeaderImg'])} id={"sevenRoomsVenueListHeaderImg"}/>
                }
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'sevenRoomsVenueListMainPageHeaderTitleContainer'])} id='sevenRoomsVenueListMainPageHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'sevenRoomsVenueListHeaderTitle'])} id='sevenRoomsVenueListHeaderTitle'>{selectedVenue?.name}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'sevenRoomsVenueListHeaderSubTitle'])} id='sevenRoomsVenueListHeaderSubTitle'>{t('reservations.reserve_table')}</Text>
                </View>
            </View>
        )
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'sevenRoomsReservationDetailsRootContainer'])} id="widgetRootContainer sevenRoomsReservationDetailsRootContainer">
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'sevenRoomsReservationDetailsMainContainer'])} 
                showsVerticalScrollIndicator={false}
                nestedScrollEnabled
                id='sevenRoomsReservationDetailsMainContainer'
            >
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'sevenRoomsReservationDetailsMainContainerChildContainer'])} id='sevenRoomsReservationDetailsMainContainerChildContainer'>

                    <View style={getStyles(['textContainer', "sevenroomsPreferredDataContainer"])} id='sevenroomsPreferredDataContainer'>
                        <Text style={getStyles(['label'])}>{t('reservations.preferred_date')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomPressable onPress={() => setIsDatePickerVisible(true)}>
                            <CustomTextInput
                                value={selectedDate ? formatDate(selectedDate, dateFormat) : ""}
                                placeholder={t('reservations.select_date_placeholder')}
                                editable={false}
                                pointerEvents="none"
                            />
                        </CustomPressable>
                    </View>

                    <View style={getStyles(['textContainer', "sevenroomsGuestCountContainer"])} id='sevenroomsGuestCountContainer'>
                        <Text style={getStyles(['label'])}>{t('reservations.guest_count')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomTextInput
                            value={guestCount < 0 ? "" : guestCount}
                            placeholder={t('reservations.guest_count_placeholder')}
                            onChangeText={(v) => setGuestCount(v)}
                            inputMode="numeric"
                        />
                    </View>


                    <View style={getStyles(['textContainer', "sevenroomsStartTimeContainer"])} id='sevenroomsStartTimeContainer'>
                        <Text style={getStyles(['label'])}>{t('reservations.preferred_start_time')}</Text>
                        <CustomDropDown
                            placeholder={t('reservations.select_start_time_placeholder')}
                            options={etaTimeList?.map((time) => {
                                return {
                                    label: formatEstimateCheckInTime(time, toBool(TIME_FORMAT)),
                                    value: time
                                }
                            })
                            }
                            selectedOption={startTime}
                            onSelectOption={(time) => {
                                setStartTime(time?.value)
                            }}
                            isSearchable={true}
                        />
                    </View>
                    
                    <View style={getStyles(['textContainer', "sevenroomsEndTimeContainer"])} id='sevenroomsEndTimeContainer'>
                        <Text style={getStyles(['label'])}>{t('reservations.preferred_end_time')}</Text>
                        <CustomDropDown
                            placeholder={t('reservations.select_end_time_placeholder')}
                            options={etaTimeList?.map((time) => {
                                return {
                                    label: formatEstimateCheckInTime(time, toBool(TIME_FORMAT)),
                                    value: time
                                }
                            })
                            }
                            selectedOption={endTime}
                            onSelectOption={(time) => {
                                setEndTime(time?.value)
                            }}
                            isSearchable={true}
                        />
                    </View>




                </View>
                

            </ScrollView>
            <View style={getStyles(['sevenRoomsReservationDetails_button_container'])} id='sevenRoomsReservationDetails_button_container'>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleGoNext} id='primaryBtn'>
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('reservations.next')}</Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack} id='secondaryBtn'>
                    <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('reservations.back')}</Text>
                </CustomPressable> */}
            </View>
            

        
            {isDatePickerVisible &&
                <DatePickerModal
                    selectedDate={selectedDate}
                    onDateChange={handleDateChange}
                    onClose={() => setIsDatePickerVisible(false)}
                    minDate={new Date()}
                />
            }

        </View>
    )
}

export default ReservationDetails
